import { useMemo } from 'react';
import { DesignSystemComponent } from 'designSystem/types';
import ComponentPreview from './ComponentPreview';
import * as S from './styles';

interface ComponentCardProps {
	component: DesignSystemComponent;
	onClick?: () => void;
	rawCode: {
		theme: string;
		styles: string;
		componentsCss: string;
		componentsJs: string;
	};
}

const ComponentCard = ({ component, onClick, rawCode }: ComponentCardProps) => {
	// Initialize props with API defaults, then overlay example props
	const props = useMemo(() => {
		const apiDefaults: Record<string, any> = {};
		component.props.forEach((prop) => {
			if (prop.defaultValue !== undefined) {
				if (prop.type === 'json') {
					try {
						apiDefaults[prop.name] = JSON.parse(prop.defaultValue);
					} catch {
						apiDefaults[prop.name] = prop.defaultValue;
					}
				} else if (prop.type === 'boolean') {
					apiDefaults[prop.name] = prop.defaultValue === 'true';
				} else if (prop.type === 'number') {
					apiDefaults[prop.name] = Number(prop.defaultValue);
				} else {
					apiDefaults[prop.name] = prop.defaultValue;
				}
			}
		});
		// Overlay example props on top of API defaults (example wins)
		return { ...apiDefaults, ...(component.exampleProps || {}) };
	}, [component.props, component.exampleProps]);

	return (
		<S.ComponentCard onClick={onClick}>
			<S.CardPreviewArea>
				<ComponentPreview
					component={component}
					props={props}
					children={component.children}
					rawCode={rawCode}
					thumbnail
				/>
			</S.CardPreviewArea>
			<S.CardName>{component.name}</S.CardName>
		</S.ComponentCard>
	);
};

export default ComponentCard;
